import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "redux/reducers/rootReducer";

const getDispensary = (state: RootState) => state.dispensary;

export const getCurrentDispensary = createSelector(
  [getDispensary],
  (dispensary) => {
    return dispensary.currentDispensary;
  },
);

export const getCurrentDeliveryZone = createSelector(
  [getDispensary],
  (dispensary) => {
    return dispensary.deliveryZone;
  },
);

const getWithinDeliveryRange = createSelector(
  [getCurrentDispensary],
  (dispensary) => {
    const {
      deliveryZoneRangeType,
      deliveryZonePostalCodeWhitelist,
      deliveryRadiusMiles,
    } = dispensary || {};

    return deliveryZoneRangeType === "postal_code"
      ? !!deliveryZonePostalCodeWhitelist?.length
      : !!deliveryRadiusMiles && deliveryRadiusMiles > 0;
  },
);

export const getAcceptsOrders = createSelector(
  [getCurrentDispensary, getWithinDeliveryRange],
  (dispensary, withinDeliveryRange) => {
    const { hasReservationsEnabled, hasDeliveryEnabled } = dispensary || {};

    return (
      hasReservationsEnabled || (hasDeliveryEnabled && withinDeliveryRange)
    );
  },
);

export const getIsDualMenu = createSelector(
  [getCurrentDispensary],
  (dispensary) => dispensary?.tags?.includes("dualLicense"),
);

export const getHasFollowed = createSelector(
  [getDispensary],
  (dispensary) => dispensary.followed,
);
